import type { TFunction } from 'i18next';
import {
  CLASSIFICATION_LABELS,
  VERIFICATION_METHOD_LABELS,
  ClassificationType,
  VerificationMethodType,
  getClassificationLabel,
  getMethodLabel,
} from '../types/verification';
import { translateWithFallback } from './translation';

export const classificationKeys = Object.keys(CLASSIFICATION_LABELS) as ClassificationType[];
export const methodKeys = Object.keys(VERIFICATION_METHOD_LABELS) as VerificationMethodType[];

export const getLocalizedClassificationLabel = (
  t: TFunction,
  key: ClassificationType | string,
): string => translateWithFallback(
  t,
  `verification.classificationLabels.${key}`,
  getClassificationLabel(key),
);

export const getLocalizedMethodLabel = (
  t: TFunction,
  key: VerificationMethodType | string,
): string => translateWithFallback(
  t,
  `verification.methodLabels.${key}`,
  getMethodLabel(key),
);
